import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import NetSuite from "./pages/NetSuite";
import Salesforce from "./pages/Salesforce";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import WebDevelopment from "./pages/WebDevelopment";
import ScheduleConsultation from "./pages/ScheduleConsultation";
import { HelmetProvider } from 'react-helmet-async';

import "./index.css";

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
     {/* 
        This handles all page-change scroll resets 
        and smooth-scrolls if the user clicks a link to the active page.
      */}
      <ScrollToTop />

      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/netsuite" element={<NetSuite />} />
        <Route path="/salesforce" element={<Salesforce />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/web-development" element={<WebDevelopment />} />
        <Route
    path="/schedule-consultation"
    element={<ScheduleConsultation />}
/>
      </Routes>

      {/* Shows on EVERY page */}
      <Footer />
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;